export const SURVEY_TRIGGERS = {
    intake: {
        en: 'Intake',
        es: 'Ingreso'
    },
    biannual: {
        en: 'Biannual',
        es: 'Semestral'
    },
    termination: {
        en: 'Termination',
        es: 'Terminación'
    },
    onboarding: {
        en: 'Onboarding',
        es: 'Incorporación'
    },
    financial: {
        en: 'Financial',
        es: 'Financiero'
    }
} as Record<string, { en: string; es: string }>;
